"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createContact = createContact;
exports.deleteContact = deleteContact;
exports.fetch = fetch;
exports.fetchByEmail = fetchByEmail;
exports.updateContactProperties = updateContactProperties;
exports.promoteEmailToPrimary = promoteEmailToPrimary;
exports.addSecondaryEmail = addSecondaryEmail;
exports.deleteSecondaryEmail = deleteSecondaryEmail;
exports.updateSecondaryEmail = updateSecondaryEmail;
exports.removeEmail = removeEmail;

var _immutable = require("immutable");

var _reduce = _interopRequireDefault(require("transmute/reduce"));

var _user = _interopRequireDefault(require("hub-http-shims/UserDataJS/user"));

var _PropertySourceTypes = require("customer-data-objects/property/PropertySourceTypes");

var _ContactRecord = _interopRequireDefault(require("customer-data-objects/contact/ContactRecord"));

var _UserScopes = require("crm_data/scopes/UserScopes");

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _sharedAPI = require("crm_data/inboundDB/sharedAPI");

var _MetaAPI = require("crm_data/meta/MetaAPI");

var _MetaProducers = _interopRequireDefault(require("crm_data/meta/MetaProducers"));

var _HTTPVerbs = require("crm_data/constants/HTTPVerbs");

var _LoadingStatus = require("crm_data/constants/LoadingStatus");

var _ContactsExtraParams = require("./ContactsExtraParams");

var _ContactsAPIQuery = require("./ContactsAPIQuery");

var BASE_URI = 'contacts/v1/contact';
var URI_CREATE = 'companies/v2/create-contact';
var CONTACT_EMAIL = 'contacts/v1/contactemail';

var getParamOptions = function getParamOptions() {
  return (0, _UserScopes.userScopes)().then(function (scopes) {
    return (0, _immutable.Map)({
      showListMemberships: scopes.has('contacts-lists-read')
    });
  });
};

function createContact(payload) {
  return (0, _ImmutableAPI.send)({
    headers: {
      'X-Properties-Source': _PropertySourceTypes.CONTACTS,
      'X-Properties-SourceId': _PropertySourceTypes.CRM_UI
    },
    type: _HTTPVerbs.POST
  }, URI_CREATE, {
    properties: payload
  }, function (result) {
    return (0, _immutable.Map)().set(result.vid, _ContactRecord.default.fromJS(result));
  });
}

function deleteContact(vid) {
  return (0, _sharedAPI.del)(BASE_URI + "/vid/" + vid);
}

function fetch(ids) {
  if (ids.size === 1) {
    var objectId = ids.first();

    var fallback = function fallback() {
      return getParamOptions().then(function (options) {
        return (0, _ImmutableAPI.send)({
          headers: {
            'X-Properties-Source': _PropertySourceTypes.CONTACTS,
            'X-Properties-SourceId': _PropertySourceTypes.CRM_UI
          },
          type: _HTTPVerbs.GET
        }, BASE_URI + "/vid/" + objectId + "/profile", (0, _ContactsExtraParams.getQueryParams)(options));
      }).catch(function (error) {
        if (error.status === 404) {
          return _LoadingStatus.EMPTY;
        }

        throw error;
      });
    };

    return (0, _MetaAPI.queueFetch)(_MetaProducers.default.CONTACT, fallback, {
      vid: parseInt(objectId, 10)
    }, function (result) {
      return (0, _immutable.Map)().set(objectId, _ContactRecord.default.fromJS(result));
    });
  }

  var query = (0, _ContactsAPIQuery.byIds)(ids);
  return getParamOptions().then(function (options) {
    return (0, _ImmutableAPI.send)({
      headers: {
        'X-Properties-Source': _PropertySourceTypes.CONTACTS,
        'X-Properties-SourceId': _PropertySourceTypes.CRM_UI
      },
      type: _HTTPVerbs.POST
    }, BASE_URI + "/vids/batch/?", (0, _ContactsExtraParams.getBodyParams)(options).merge(query), function (result) {
      return (0, _reduce.default)((0, _immutable.Map)(), function (coll, val, key) {
        return coll.set(key, _ContactRecord.default.fromJS(val));
      }, result);
    });
  });
}

function fetchByEmail(email) {
  return getParamOptions().then(function (options) {
    return (0, _ImmutableAPI.send)({
      headers: {
        'X-Properties-Source': _PropertySourceTypes.CONTACTS,
        'X-Properties-SourceId': _PropertySourceTypes.CRM_UI
      },
      type: _HTTPVerbs.GET
    }, BASE_URI + "/email/" + email + "/profile", (0, _ContactsExtraParams.getQueryParams)(options), function (result) {
      return (0, _immutable.Map)().set(result.vid, _ContactRecord.default.fromJS(result));
    });
  });
}

function updateContactProperties(contact, updates) {
  var vid = contact.get('vid');
  return (0, _ImmutableAPI.send)({
    headers: {
      'X-Properties-Source': _PropertySourceTypes.CONTACTS,
      'X-Properties-SourceId': _PropertySourceTypes.CRM_UI,
      'X-Properties-Flag': 'FORCE_LIFECYCLE_STAGE'
    },
    type: _HTTPVerbs.POST
  }, BASE_URI + "/vid/" + contact.get('vid') + "/profile", {
    vid: vid,
    properties: updates.reduce(function (acc, value, property) {
      acc.push({
        property: property,
        value: value,
        source: _PropertySourceTypes.CRM_UI,
        'source-id': _user.default.get().get('email')
      });
      return acc;
    }, [])
  });
}

function promoteEmailToPrimary(vid, email) {
  return (0, _ImmutableAPI.send)({
    headers: {
      'X-Properties-Source': _PropertySourceTypes.CONTACTS,
      'X-Properties-SourceId': _PropertySourceTypes.CRM_UI
    },
    type: _HTTPVerbs.POST
  }, CONTACT_EMAIL + "/" + vid + "/secondary-email/" + encodeURIComponent(email) + "/promote");
}

function addSecondaryEmail(vid, email) {
  return (0, _ImmutableAPI.send)({
    headers: {
      'X-Properties-Source': _PropertySourceTypes.CONTACTS,
      'X-Properties-SourceId': _PropertySourceTypes.CRM_UI
    },
    type: _HTTPVerbs.POST
  }, CONTACT_EMAIL + "/" + vid + "/secondary-email/" + encodeURIComponent(email));
}

function deleteSecondaryEmail(vid, email) {
  return (0, _ImmutableAPI.send)({
    headers: {
      'X-Properties-Source': _PropertySourceTypes.CONTACTS,
      'X-Properties-SourceId': _PropertySourceTypes.CRM_UI
    },
    type: _HTTPVerbs.DELETE
  }, CONTACT_EMAIL + "/" + vid + "/secondary-email/" + encodeURIComponent(email));
}

function updateSecondaryEmail(vid, prevEmail, nextEmail) {
  return (0, _ImmutableAPI.send)({
    headers: {
      'X-Properties-Source': _PropertySourceTypes.CONTACTS,
      'X-Properties-SourceId': _PropertySourceTypes.CRM_UI
    },
    type: _HTTPVerbs.PUT
  }, CONTACT_EMAIL + "/" + vid + "/secondary-email/" + encodeURIComponent(prevEmail) + "/" + encodeURIComponent(nextEmail));
}

function removeEmail(vid, email) {
  return (0, _ImmutableAPI.send)({
    headers: {
      'X-Properties-Source': _PropertySourceTypes.CONTACTS,
      'X-Properties-SourceId': _PropertySourceTypes.CRM_UI
    },
    type: _HTTPVerbs.DELETE
  }, CONTACT_EMAIL + "/" + vid + "/secondary-email/" + encodeURIComponent(email));
}